<template>
  <div>
    <!--BEGIN DROPDOWN Custom margin-right:77px;-->
    <div
      class="form-group"
      :class="!item.isSelectInvoiceStatus && !item.apartment ? 'select-option-default' : 'select-option-custom'"
    >
      <label
        v-show="item.showLabel"
        for="location"
        class="control-label"
        :class="[item.cssClassSm1, (item.required == true || item.required == undefined) ? 'required' : '']"
      >{{item.titleLabel != undefined ? item.titleLabel : $t('property.asset.type')}}</label>
      <div
        class="dropdown"
        :class="item.cssClassSm2"
        style="width:300px;position:relative;float:right;border:0px solid red;"
      >
        <lte-button
            v-if="!item.isSelectInvoiceStatus && !item.apartment"
            style="float:right;background-color:white !important;margin-top:0px;"
            type="btn btn-default"
            right_icon="fa fa-eye"
            :value="setItemType"
            @click="showAdvanceFilter"
        >{{$t('common.columns')}}</lte-button>
        <lte-button
            v-else-if="item.isSelectInvoiceStatus"
            class="select-option-invoice"
            style="float:left;background-color:white !important;margin-top:0px;margin-left: -16px;"
            type="btn btn-default"
            :value="setItemType"
            @click="showAdvanceFilter"
        >{{$t('common.status')}}</lte-button>
        <lte-button
            v-else
            class="select-option-status-apartment"
            style="float:left;background-color:white !important;margin-top:0px;margin-left: -16px; width: '100%'"
            type="btn btn-default"
            :value="setItemType"
            @click="showAdvanceFilter"
        >{{$t('common.status')}}</lte-button>
        <div
          v-if="isShowAdvanceFilter"
          v-show="isShowAdvanceFilter"
          v-click-outside="outside"
          @click="inside"
          class="dropdown-menu dropdown"
          style="width:95%;z-index:10;margin-top:0px;float:left;border:1px solid #dbdbdb;"
        >
          <div class="dropdown-title">
            <button
              class="dropdown-title-button dropdown-menu-close"
              type="button"
              @click="closeAdvanceFilter"
              style="margin-top:-2px;"
            >
              <i aria-hidden="true" data-hidden="true" class="fa fa-times dropdown-menu-close-icon"></i>
            </button>
          </div>
          <!-- Content -->
          <div class="dropdown-content" style="margin-top:10px;float:left;width:100%">
            <ul>
              <li v-for="itemtype in filteredItemTypeItems" :key="itemtype.id">
                <a class="label-item" @click="getItemType(itemtype)">
                  <span class="dropdown-label-box" style="background: #AD8D43;"></span>
                  {{$t(itemtype.text)}}
                </a>
                <span v-if="itemtype.isHidden">
                  <i
                    aria-hidden="true"
                    data-hidden="true"
                    class="fa fa-check"
                    style="float:right;margin:-22px 30px;"
                  ></i>
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!-- END DROPDOWN Custom-->

    <!--BEGIN FORM ADD NEW ASSET Custom -->
    <div class="form-group" style="border:0px solid red;max-height:0px;margin-top:0px;">
      <label for="location" class="control-label" :class="item.cssClassSm1"></label>
      <div class="dropdown" :class="item.cssClassSm2">
        <div
          v-if="isShowNewItemType"
          v-show="isShowNewItemType"
          v-click-outside="outside"
          @click="inside"
          class="dropdown-menu dropdown"
          id="your-custom-id-material"
          style="
                        width:95%;
                        z-index:20;
                        min-height: 40px;
                        max-height: 312px;"
          :style="item.modifyFromPosition"
        ></div>
      </div>
    </div>
    <!-- END FORM ADD NEW ASSET Custom -->
  </div>
</template>

<script>
import { mapActions } from "vuex";
import LTEButton from "@/components/LTEButton.vue";
export default {
  name: "SelectOption",
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      data_list: [],
      isShowAdvanceFilter: false,
      isShowNewItemType: false,
      opened: false,
      item_type: [],
      strSearch: "",
      changeIcon: false,
      itemType: null,
      keepItemType: 1,
      itemtypedata: {
        name: ""
      }
    };
  },
  watch: {},
  computed: {
    setItemType: function() {
      let set_item_type = "";
      this.create();
      this.data_list.forEach(v => {
        if (this.$t(v.text) == this.itemType) {
          set_item_type = this.$t(v.text);
        }
      });
      // let type_value = this.itemType;
      // this.$emit("onchangeselect", type_value);
      return set_item_type;
    },
    filteredItemTypeItems() {
      return this.data_list.filter(item => {
        return (
          this.$t(item.text)
            .toLowerCase()
            .indexOf(this.strSearch.toLowerCase()) > -1
        );
      });
    }
  },
  methods: {
    ...mapActions([
      "ERROR_TOAST",
      "SUCCESS_TOAST"
    ]),
    create() {
      this.data_list = this.item.data_list;
      this.itemType = this.item.itemType;
    },

    showAdvanceFilter: function(val) {
      this.isShowAdvanceFilter = true;
      this.opened = true;
    },
    outside: function(e) {
      if (this.opened) {
        //console.log("clicked outside!");
        this.opened = false;
      } else {
        this.isShowAdvanceFilter = false;
        this.isShowNewItemType = false;
      }
    },
    inside: function(e) {
      //console.log("clicked inside!");
      if (this.opened) {
        this.isShowNewItemType
          ? (this.isShowAdvanceFilter = false)
          : (this.isShowAdvanceFilter = true);
      }
    },
    closeAdvanceFilter: function(e) {
      this.opened = false;
      this.isShowAdvanceFilter = false;
    },
    getItemType: function(item) {
      this.item.data_list.forEach(v => {
        if (v.text == item.text) {
          v.isHidden = !item.isHidden;
        }
      });
      this.item.itemType = item;
      this.itemType = item;
      this.$emit("callbackData", this.item);
      this.$emit("invoiceStatusData", this.item)
      this.$emit("callbackPerMonthData", this.item)
      this.$emit("callbackUncategorized", this.item)
      this.$emit("apartmentStatusSeleted", this.item)
    }
  },
  mounted() {
    this.create();
  },
  components: {
    "lte-button": LTEButton
  },
  directives: {
    "click-outside": {
      bind: function(el, binding, vNode) {
        // Provided expression must evaluate to a function.
        if (typeof binding.value !== "function") {
          const compName = vNode.context.name;
          // let warn = `[Vue-click-outside:] provided expression '${
          //   binding.expression
          // }' is not a function, but has to be`;
          if (compName) {
            warn += `Found in component '${compName}'`;
          }
          //console.warn(warn);
        }
        // Define Handler and cache it on the element
        const bubble = binding.modifiers.bubble;
        const handler = e => {
          if (bubble || (!el.contains(e.target) && el !== e.target)) {
            binding.value(e);
          }
        };
        el.__vueClickOutside__ = handler;
        // add Event Listeners
        document.addEventListener("click", handler);
      },

      unbind: function(el, binding) {
        // Remove Event Listeners
        document.removeEventListener("click", el.__vueClickOutside__);
        el.__vueClickOutside__ = null;
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@media only screen and (max-width: 1450px){
    .select-option-invoice,
    .select-option-status-apartment {
        float: right;
        margin-left: 0px;
    }
}
@media only screen and (max-width: 768px){
    .select-option-invoice,
    .select-option-status-apartment {
        float: right;
        margin-left: 0px;
    }
}
.select-option-default {
  margin-top:-3px;
  border:0px solid green;
  float:right;
  margin-right:-14px;
  width:500px
}
.select-option-custom {
  margin-top:-3px;
  border:0px solid green;
  float:right;
  margin-right:-14px;
}
.dropdown .dropdown-menu,
.dropdown .dropdown-menu-nav {
  transform: translateY(0);
  display: block;
  min-height: 40px;
  max-height: 312px;
  overflow-y: auto;
  // z-index: 300;
  margin-top: 4px;
  margin-bottom: 24px;
  font-size: 14px;
  font-weight: 400;
  padding: 8px 0;
  background-color: #fff;
  border: 1px solid #e5e5e5;
  border-radius: 3px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.dropdown-menu-labels .dropdown-content {
  max-height: 135px;
}
.dropdown-menu .divider,
.dropdown-menu-nav .divider {
  height: 1px;
  margin: 4px 0;
  padding: 0;
  background-color: #dfdfdf;
}

.dropdown-content {
  // max-height: 252px;
  max-height: auto;
  overflow-y: auto;
  max-width: auto;
}

.dropdown-menu ul,
.dropdown-menu-nav ul {
  margin: 0;
  padding: 0;
}
ul {
  display: block;
  list-style-type: disc;
  margin-block-start: 1em;
  margin-block-end: 1em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
  padding-inline-start: 40px;
}
.dropdown-menu li,
.dropdown-menu-nav li {
  display: block;
  text-align: left;
  list-style: none;
  padding: 0 1px;
}

.dropdown-menu li a,
.dropdown-menu li button,
.dropdown-menu li .menu-item,
.dropdown-menu-nav li a,
.dropdown-menu-nav li button,
.dropdown-menu-nav li .menu-item {
  background: transparent;
  border: 0;
  border-radius: 0;
  box-shadow: none;
  display: block;
  font-weight: 400;
  position: relative;
  padding: 8px 12px;
  color: #2e2e2e;
  line-height: 16px;
  white-space: normal;
  overflow: hidden;
  text-align: left;
  width: 98%;
}

.dropdown-menu a,
.dropdown-menu button,
.dropdown-menu-nav a {
  transition: none;
}
.dropdown-content ul li:hover,
.dropdown-footer ul li:hover a {
  background-color: #eee;
  color: #2e2e2e;
  outline: 0;
  text-decoration: none;
}
.dropdown-input-field:focus {
  color: #555;
  border-color: #73afea;
  box-shadow: 0 0 4px rgba(115, 175, 234, 0.4);
}

.dropdown-title {
  position: relative;
  padding: 8px 12px;
  padding-bottom: 16px;
  margin-bottom: 8px;
  font-weight: 600;
  line-height: 1;
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
  border-bottom: 1px solid #dfdfdf;
  overflow: hidden;
}

.dropdown-title-button {
  position: absolute;
  top: 0;
  padding: 0;
  color: #bfbfbf;
  font-size: 14px;
  border: 0;
  background: none;
  outline: 0;
  margin: 10px 0px 0px 40%;
}

.form-goback-title-button {
  position: absolute;
  top: 0;
  padding: 0;
  color: #bfbfbf;
  font-size: 14px;
  border: 0;
  background: none;
  outline: 0;
}

.form-close-title-button {
  position: absolute;
  top: 0;
  padding: 0;
  color: #bfbfbf;
  font-size: 14px;
  border: 0;
  background: none;
  outline: 0;
}

.dropdown-menu-close {
  right: 5px;
  width: 20px;
  height: 20px;
  top: -1px;
}

.dropdown-menu-back {
  left: 7px;
  top: 2px;
}

.dropdown-labels-error {
  padding: 5px 10px;
  margin-bottom: 10px;
  background-color: #db3b21;
  color: #fff;
  width: 95%;
  margin-right: auto;
  margin-left: auto;
  min-height: 30px;
  padding: 0px 7px;
}

label.required:not(:empty):after,
.field-header.required:after {
  content: " *";
  color: red;
  position: absolute;
  right: 5px;
  top: 0px;
}
</style>




// WEBPACK FOOTER //
// src/components/SelectOptionCheck.vue